import { Check, Sparkles } from 'lucide-react';

const WhatIsThriveMaxSection = () => {
  const bullets = [
    "Unlimited Home Safety Checks",
    "Daily check-ins + your personal ThriveScore",
    "7 AI companions for health, safety, cooking, and more",
    "You + 1 family member, share when you're ready"
  ];

  return (
    <section className="py-12 lg:py-16 border-b border-border/50">
      <div className="max-w-3xl mx-auto text-center">
        {/* Header */}
        <div className="inline-flex items-center gap-2 mb-4">
          <Sparkles className="w-5 h-5 text-primary" />
          <h2 className="text-2xl lg:text-3xl font-bold text-foreground tracking-tight">
            Your Complete Independence Toolkit
          </h2>
        </div>

        {/* Body */}
        <p className="text-lg text-muted-foreground leading-relaxed mb-8 max-w-2xl mx-auto">
          SeniorThrive brings safety, wellness, and everyday life into one place, so you
          can stay ahead of risks and focus on what matters most.
        </p>

        {/* Bullets */}
        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-6">
          {bullets.map((bullet, index) => (
            <div
              key={index}
              className="flex items-center gap-2 text-foreground/90"
            >
              <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0">
                <Check className="w-5 h-5 text-primary" strokeWidth={3} />
              </div>
              <span className="text-sm">{bullet}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIsThriveMaxSection;
